/**
 * OVERRIDE Edit.jsx
 * REASON: To allow new display options to be reflected in real-time in the block edit view.
 */

import ListingBodyEdit from '../../../../../../components/Blocks/Listing/ListingBodyEdit';

export default ListingBodyEdit;